import type { FC } from 'react';

/**
 * Shows a masking pattern as left-to-right text (PSTUDIO-4123, S17/S38).
 *
 * The direction is set on a NATIVE `<span>` that directly contains the
 * characters, instead of on the `ps-text-body` that wraps it: `dir` on that host
 * was measured in the browser NOT to reach the rendered text under `ar`. Slotted
 * text is light-DOM content, so the span it sits in is what the bidi algorithm
 * reads. `unicodeBidi: 'isolate'` keeps the pattern from reordering with its
 * surroundings.
 *
 * Deliberately free of design-system imports so a jsdom test can render it.
 */
export const MaskingPatternText: FC<{ pattern: string }> = ({ pattern }) => (
  <span
    data-testid="masking-pattern-text"
    dir="ltr"
    style={{ unicodeBidi: 'isolate' }}
  >
    {pattern}
  </span>
);
